import React from 'react';

export default function IconZA() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path fill="#464655" d="M0 4.38v13.24L8.828 11 0 4.38Z" />
            <path
                fill="#FF4B55"
                d="m4.414.517 9.931 7.724H32V1.07a.552.552 0 0 0-.552-.552H4.414Z"
            />
            <path
                fill="#41479B"
                d="m4.414 21.483 9.931-7.724H32v7.172a.552.552 0 0 1-.552.552H4.414Z"
            />
            <path
                fill="#73AF00"
                d="M3.556.517H.552A.552.552 0 0 0 0 1.07v2.263L9.686 11 0 18.668v2.263c0 .305.247.552.552.552h3.003l10.454-8.276H32V8.793H14.01L3.555.517Z"
            />
            <path fill="#F5F5F5" d="M5.333.517H3.556l10.453 8.276H32V7.69H14.393L5.333.517Z" />
            <path fill="#FFE15A" d="M0 3.332V4.74L7.908 11 0 17.26v1.408L9.686 11 0 3.332Z" />
            <path fill="#F5F5F5" d="M14.01 13.207 3.556 21.483h1.777l9.06-7.173H32v-1.103H14.01Z" />
        </svg>
    );
}
